import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store/store'
import Welcome from '@/components/Welcome'
import Login from '@/components/Login'
import Logout from '@/components/Logout'
import Generate from '@/components/Generate'
import UserList from '@/components/UserList'
import User from '@/components/User'
import Menu from '@/components/Menu'
import Search from '@/components/Search'
import CompleteLicense from '@/components/CompleteLicense'
import DeleteLicense from '@/components/DeleteLicense'
import ModifyLicense from '@/components/ModifyLicense'
import ConfirmLicense from '@/components/ConfirmLicense'
import OpList from '@/components/OpList'
import LicenseHistory from '@/components/LicenseHistory'
import EventLog from '@/components/EventLog'
import UserForm from '@/components/UserForm'
import SetHwInfo from '@/components/SetHwInfo'
import GenLocalLicense from '@/components/GenLocalLicense'
import CustomerList from '@/components/CustomerList'
import CustomerForm from '@/components/CustomerForm'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Login',
    component: Login
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/logout',
    name: 'Logout',
    component: Logout
  },
  {
    path: '/welcome',
    name: 'Welcome',
    meta: {
      requireAuth: true
    },
    component: Welcome
  },
  {
    path: '/generate',
    name: 'Generate',
    meta: {
      requireAuth: true
    },
    component: Generate
  },
  {
    path: '/users',
    name: 'UserList',
    meta: {
      requireAuth: true
    },
    component: UserList
  },
  {
    path: '/user/:id',
    name: 'User',
    meta: {
      requireAuth: true
    },
    component: User
  },
  {
    path: '/menu',
    name: 'Menu',
    meta: {
      requireAuth: true
    },
    component: Menu
  },
  {
    path: '/search',
    name: 'Search',
    meta: {
      requireAuth: true
    },
    component: Search
  },
  {
    path: '/completeLicense',
    name: 'CompleteLicense',
    meta: {
      requireAuth: true
    },
    component: CompleteLicense
  },
  {
    path: '/deleteLicense',
    name: 'DeleteLicense',
    meta: {
      requireAuth: true
    },
    component: DeleteLicense
  },
  {
    path: '/modifyLicense',
    name: 'ModifyLicense',
    meta: {
      requireAuth: true
    },
    component: ModifyLicense
  },
  {
    path: '/confirmLicense',
    name: 'ConfirmLicense',
    meta: {
      requireAuth: true
    },
    component: ConfirmLicense
  },
  {
    path: '/opList',
    name: 'OpList',
    meta: {
      requireAuth: true
    },
    component: OpList
  },
  {
    path: '/licenseHistory',
    name: 'LicenseHistory',
    meta: {
      requireAuth: true
    },
    component: LicenseHistory
  },
  {
    path: '/eventLog',
    name: 'EventLog',
    meta: {
      requireAuth: true
    },
    component: EventLog
  },
  {
    path: '/userForm',
    name: 'UserForm',
    meta: {
      requireAuth: true
    },
    component: UserForm
  },
  {
    path: '/setHwInfo',
    name: 'SetHwInfo',
    meta: {
      requireAuth: true
    },
    component: SetHwInfo
  },
  {
    path: '/genLocalLicense',
    name: 'GenLocalLicense',
    meta: {
      requireAuth: true
    },
    component: GenLocalLicense
  },
  {
    path: '/customerList',
    name: 'CustomerList',
    meta: {
      requireAuth: true
    },
    component: CustomerList
  },
  {
    path: '/customerForm',
    name: 'CustomerForm',
    meta: {
      requireAuth: true
    },
    component: CustomerForm
  }
]

const router = new VueRouter({
  routes
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(r => r.meta.requireAuth)) {
    if (store.state.token) {
      next()
    } else {
      next({
        path: '/login'
        // query: {redirect: to.fullPath}
      })
    }
  } else {
    next()
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js